import React from 'react';
import * as ReactDOM from "react-dom";
import Game from "../Game";
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import {format} from "react-string-format";
import {Col, Container, Row} from "react-bootstrap";

class AdminPayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isLoadedPayout: false,
            isLoadedData: false,
            userId: null,
            loginError: null,
            payout: null
        };
    }

    loadPayouts(){
        if (!this.state.loginError && this.state.isLoaded && this.props.payoutId) {
            fetch(process.env.REACT_APP_API_URL + "/payouts/"+this.props.payoutId, {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoadedPayout: true,
                            payout: result
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoadedPayout: false,
                            error
                        });
                    }
                )
        }
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    if (result.role.name !== 'admin') {
                        this.setState({
                            isLoaded: true,
                            loginError: 'unauthorized'
                        });
                    } else {
                        this.setState({
                            isLoaded: true,
                            userId: result.id
                        }, this.loadPayouts);
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        loginError: "unauthorized",
                    });
                }
            );
    }

    approvePayout(e){
        e.preventDefault();

        this.setState({
            isLoadedPayout: false
        });

        fetch(process.env.REACT_APP_API_URL + "/payouts/"+e.target.id.value+"/approve", {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(
                (result) => {
                    this.componentDidMount()

                    this.setState({
                        isLoadedPayout: true
                    });
                },

                (error) => {
                    console.log(error);

                    this.componentDidMount()

                    this.setState({
                        isLoadedPayout: true
                    });
                }
            )
    }

    render() {
        const { isLoaded, isLoadedPayout, isLoadedData, adminData, payout, loginError} = this.state;

        const { navigate } = this.props;

        let content = "Loading...";

        if (isLoadedPayout){
            content = <div>
                <div class={payout.status==='in_review' ? "alert alert-warning" : "alert alert-success"}>
                    ${payout.amount}
                    <br/>
                        {payout.created_at}
                        <br/>
                        <a href={"/customer/" + payout.user.id}>{payout.user.email}</a>
                        <br/>
                        {payout.status ==='in_review' ? "In review" : "Confirmed"}
                        <div>
                            {payout.user.user_payment_card.map(payout => (
                                payout.is_default ? <div>
                                    {payout.number}
                                    <br/>
                                    {payout.address.country}, {payout.address.state}, {payout.address.city}
                                    <br/>
                                    {payout.address.line1}
                                    <br/>
                                    {payout.address.postal_code}
                                </div> : <br/>
                            ))}
                        </div>
                    {payout.status ==='in_review' ? <form onSubmit={this.approvePayout.bind(this)}>
                            <input type="number" name="id" hidden value={payout.id}/>
                            <input type="submit" value="Approve" className="btn btn-success"/>
                        </form> : <br/>}
                    </div>
            </div>
        }

        if (loginError) {
            navigate('/account');
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>
    }
}

export default withRouter(AdminPayout);
